import type { NaverLocalSearchItem } from '@/shared/types';
import SearchNaverResultItem from './SearchNaverResultItem';

type SearchNaverResultListProps = {
	results: NaverLocalSearchItem[];
	highlight: string;
};

const SearchNaverResultList = ({
	results,
	highlight,
}: SearchNaverResultListProps) => {
	return (
		<section className="flex w-full flex-col">
			<ul className="w-full">
				{results.map((suggestion) => (
					<SearchNaverResultItem
						key={suggestion.title}
						suggestion={suggestion}
						highlight={highlight}
					/>
				))}
			</ul>
		</section>
	);
};

export default SearchNaverResultList;
